import { financeNames } from '../../../modules/json/financeNames';

export function getDefaultTerm(brand, key) {
    return 48;
}

export function getDefaultMileage(brand, key) {
    return 10000;
}

export function getDefaultDeposit(vehicle = {}, key) {
    if (typeof vehicle.age == 'undefined') {
        return 2315;
    }
    const age = new Number(vehicle.age);
    if (isNaN(age)) {
        return 2315;
    }
    if (age <= 3) {
        return 4000;
    }
    if (age <= 5) {
        return 3000;
    }
    if (age <= 7) {
        return 2000;
    }
    return 1000;
}

export function getFinanceNameFromKey(vehicle, key, useShortName = false) {
    if (useShortName) {
        const shortName = getFinanceNameFromKey(vehicle, key + '.short', false);
        if (shortName !== 'Finance') {
            if (shortName == 'Hire Purchase') {
                return 'Conditional Sale';
            }
            if (shortName == 'HP') {
                return 'CS';
            }
            return shortName;
        }
    }
    if (typeof financeNames[vehicle.brand + '.' + key] !== 'undefined') {
        if (financeNames[vehicle.brand + '.' + key] == 'Hire Purchase') {
            return 'Conditional Sale';
        }
        return financeNames[vehicle.brand + '.' + key];
    }
    if (vehicle.brand == 'randd' || vehicle.brand == '' || vehicle.brand == 'RobinsAndDay' || vehicle.brand == false) {
        if (typeof financeNames[vehicle.manufacturer.toLowerCase() + '.' + key] !== 'undefined') {
            if (financeNames[vehicle.manufacturer.toLowerCase() + '.' + key] == 'Hire Purchase') {
                return 'Conditional Sale';
            }
            return financeNames[vehicle.manufacturer.toLowerCase() + '.' + key];
        }
    }
    if (typeof financeNames['.' + key] !== 'undefined') {
        if (financeNames['.' + key] == 'Hire Purchase') {
            return 'Conditional Sale';
        }
        return financeNames['.' + key];
    }
    return 'Finance';
}

export function getPayments(quote) {
    const financeQuote = quote.Quote;
    const payments = financeQuote.Payments || false;
    if (payments === false) {
        return false;
    }

    const firstPaymentsQuantity = payments[0]?.NumberOfPayments || false;
    const firstPaymentsValue = payments[0]?.Amount || 0.00;
    const regularPaymentsQuantity = payments[1]?.NumberOfPayments || false;
    const regularPaymentsValue = payments[1]?.Amount || false;

    if (firstPaymentsQuantity !== false && firstPaymentsValue !== false && regularPaymentsQuantity !== false && regularPaymentsValue !== false && payments.length === 3) {
        return [
            {
                quantity: firstPaymentsQuantity,
                amount: firstPaymentsValue
            },
            {
                quantity: regularPaymentsQuantity,
                amount: regularPaymentsValue
            }
        ];
    }

    let numberOfPayments = 0;
    payments.forEach((element, index) => {
        if (typeof element.NumberOfPayments == 'undefined') {
            return;
        }
        numberOfPayments = numberOfPayments + parseInt(element.NumberOfPayments);
    });

    if (payments.length == 2) {
        const finalMonths = payments[1].NumberOfPayments || 0;
        return [
            {
                quantity: numberOfPayments - finalMonths,
                amount: financeQuote.AllInclusiveRegularPayment,
            }
        ];
    }

    return [
        {
            quantity: numberOfPayments,
            amount: financeQuote.AllInclusiveRegularPayment,
        }
    ];
};

export function getDepositContribution(quote) {
    let depCon = 0.0;

    if (typeof quote.Quote.DepositContributions !== 'undefined') {
        quote.Quote.DepositContributions.forEach(element => {
            if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                depCon = depCon + parseFloat(element.Amount);
            }
        });
        return depCon;
    }

    if (typeof quote.Notifications.Public !== 'undefined') {
        quote.Notifications.Public.forEach(financeNotification => {
            if (financeNotification.Code == "9" && financeNotification.Value > 0) {
                depCon = depCon + financeNotification.Value;
            }
        });
        return depCon;
    }

    return depCon;
};

export function getDepositContributionExcludingDealer(quote) {
    let depCon = 0.0;

    if (typeof quote.Quote.DepositContributions !== 'undefined') {
        quote.Quote.DepositContributions.forEach(element => {
            if (typeof element.Name !== 'undefined' && element.Name == 'Dealer Contribution') {
                return;
            }
            if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                depCon = depCon + parseFloat(element.Amount);
            }
        });
        return depCon;
    }

    if (typeof quote.Notifications.Public !== 'undefined') {
        quote.Notifications.Public.forEach(financeNotification => {
            if (financeNotification.Code == "9" && financeNotification.Value > 0) {
                depCon = depCon + parseFloat(financeNotification.Value);
            }
        });
        return depCon;
    }

    if (typeof quote.Quote.DepositContribution !== 'undefined') {
        return parseFloat(quote.Quote.DepositContribution);
    }

    return depCon;
};

export function getDealerDepositContribution(quote) {
    let depCon = 0;

    if (typeof quote.Quote.DepositContributions !== 'undefined') {
        quote.Quote.DepositContributions.forEach(element => {
            if (typeof element.Name == 'undefined' || element.Name != 'Dealer Contribution') {
                return;
            }
            if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                depCon = depCon + parseFloat(element.Amount);
            }
        });
        return depCon;
    }

    return 0;
};

export function getFirstFee(quote) {
    if (typeof quote.Quote.Fees == 'undefined') {
        return 0.00;
    }

    let feesLength = quote.Quote.Fees.length;
    if (feesLength == 0) {
        return 0.00;
    }

    let firstFee = quote.Quote.Fees[0];
    if (typeof firstFee.Amount == 'undefined') {
        return 0.00;
    }

    return parseFloat(firstFee.Amount);
};

export function getFinalPayment(quote) {
    if (typeof quote.Quote.FinalPayment !== 'undefined') {
        return quote.Quote.FinalPayment;
    }

    if (typeof quote.Quote.Payments == 'undefined') {
        return 0.00;
    }

    let paymentsLength = quote.Quote.Payments.length;
    if (paymentsLength == 0) {
        return 0.00;
    }

    let lastPayment = quote.Quote.Payments[paymentsLength - 1];
    if (typeof lastPayment.NumberOfPayments == 'undefined' || lastPayment.NumberOfPayments > 1) {
        return 0.00;
    }
    if (typeof lastPayment.Amount == 'undefined') {
        return 0.00;
    }

    return lastPayment.Amount;
}

export function getRoadsideAssistance(quote) {
    if (typeof quote.Quote.Breakdown == 'undefined' || quote.Quote.Breakdown.length == 0) {
        return 0;
    }

    let roadsideAssistance = 0;
    for (let i = 0, len = quote.Quote.Breakdown.length; i < len; i++) {
        if (quote.Quote.Breakdown[i].Type && quote.Quote.Breakdown[i].Type == 'Roadside Assistance') {
            roadsideAssistance += quote.Quote.Breakdown[i].Amount;
        }
    }

    return roadsideAssistance;
}

export function getGovernmentGrant(quote) {
    if (typeof quote.Quote.CashPriceDiscounts == 'undefined' || quote.Quote.CashPriceDiscounts.length == 0) {
        return 0;
    }
    let governmentGrant = 0;
    for (let i = 0, len = quote.Quote.CashPriceDiscounts.length; i < len; i++) {
        if (quote.Quote.CashPriceDiscounts[i].Name && quote.Quote.CashPriceDiscounts[i].Name == 'Government Grant') {
            governmentGrant += quote.Quote.CashPriceDiscounts[i].Amount;
        }
    }

    return governmentGrant;
};

export function getEmptyQuoteWithPredictableKeys() {
    return {
        numPayments: null,
        monthly: null,
        depCon: null,
        depConExcludingDealer: null,
        dealerDepCon: null,
        firstFee: null,
        finalPayment: null,
        roadsideAssistance: null,
        governmentGrant: null,
        apr: null,
        financePrice: null,
    };
}